import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <div className="privacy-policy-wrapper">
        <h2 className="privacy-policy-title">Privacy Policy</h2>
        <p className="privacy-policy-intro">
          This Privacy Policy explains how Igbo-Eze North Local Government collects, uses, and protects your personal data when you use our website or services.
        </p>

        <section className="privacy-section">
          <h3>1. Information We Collect</h3>
          <ul>
            <li>Personal information (e.g. name, email, phone) if submitted through forms or contact pages.</li>
            <li>Usage data such as browser type, pages visited, and time spent on the website.</li>
            <li>Technical data from cookies or analytics tools (e.g. IP address, device info).</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h3>2. How We Use Your Information</h3>
          <ul>
            <li>To provide and maintain our services.</li>
            <li>To respond to your inquiries or feedback.</li>
            <li>To analyze website usage and improve performance.</li>
            <li>To comply with legal obligations.</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h3>3. Data Sharing and Third Parties</h3>
          <ul>
            <li>We do not sell your personal information.</li>
            <li>We may share data with trusted third-party services (e.g. analytics or hosting) for operational purposes.</li>
            <li>We ensure all third parties follow strict data protection policies.</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h3>4. Your Data Rights</h3>
          <ul>
            <li>You have the right to access, correct, or request deletion of your personal data.</li>
            <li>You may opt out of certain data uses by contacting us.</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h3>5. Data Security</h3>
          <p>
            We take reasonable technical and organizational measures to protect your information from unauthorized access, alteration, or disclosure.
          </p>
        </section>

        <section className="privacy-section">
          <h3>6. Cookies</h3>
          <p>
            Our site may use cookies to enhance user experience. You may adjust your browser settings to refuse cookies if you prefer.
          </p>
        </section>

        <section className="privacy-section">
          <h3>7. Contact Us</h3>
          <p>
            If you have any questions about this Privacy Policy or want to exercise your rights, please contact us via the <strong>Contact</strong> page or email us at <a href="mailto:info@igboezenorth.gov.ng">info@igboezenorth.gov.ng</a>.
          </p>
        </section>

        <p className="privacy-policy-update">Last updated: June 21, 2025</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;